// Guard pour le typage du Ctrl Ref provenant du champ DateTime pour l'initialisation des dates.

import { CtrlRefDateTime } from '90.quickConnect.Models/models';

// exemple: {"controlId":"##DateTime2","type":5,"snippet":"CtrlRef(__val1__)"}

export const isCtrlRefDateTime = (o: any): o is CtrlRefDateTime =>
  'controlId' in o && typeof o.controlId === 'string' && 'type' in o && typeof o.type === 'number';
